<template>
  <Poptip
    v-model="showPop"
    placement="bottom"
    transfer
    @on-popper-hide="handleHide"
    padding="0 0 6px 0"
  >
    <Icon
      :class="checkedItem[0] ? 'filter-checked' : ''"
      style="cursor: pointer"
      type="ios-funnel-outline"
    />
    <div slot="content">
      <Input
        v-model="value"
        placeholder="搜索"
        style="width: 200px"
        prefix="md-search"
      />
      <CheckboxGroup
        v-if="isState"
        v-model="checkAllGroup"
        @on-change="checkAllGroupChange"
      >
        <div>
          <Checkbox label="1" style="display: block; padding: 6px 10px"
            >更新中
          </Checkbox>
          <Checkbox label="2" style="display: block; padding: 6px 10px"
            >更新成功
          </Checkbox>
          <Checkbox label="3" style="display: block; padding: 6px 10px"
            >排队中
          </Checkbox>
          <Checkbox label="4" style="display: block; padding: 6px 10px"
            >更新失败
          </Checkbox>
        </div>
      </CheckboxGroup>
      <CheckboxGroup
        v-model="checkedItem"
        style="overflow: auto; max-height: 200px"
        v-else
      >
        <div v-if="filterList">
          <Checkbox
            v-for="item in filterList"
            :label="item.value"
            :key="item._uid"
            style="display: block"
          >
            {{ item.label }}
          </Checkbox>
        </div>
        <div v-else class="dataNull">空</div>
      </CheckboxGroup>

      <div class="filter-footer">
        <div class="filter-footer-content">
          <div class="filter-footer-left">
            <Checkbox
              v-if="isState"
              :indeterminate="indeterminate"
              :value="checkAll"
              @click.prevent.native="handleCheckAll"
              >全选</Checkbox
            >
            <div v-else></div>
          </div>
          <div class="filter-footer-right">
            <Button type="text" size="small" @click="handleCancel">重置</Button>
            <Button type="primary" size="small" @click="handleSave"
              >确定</Button
            >
          </div>
        </div>
      </div>
    </div>
  </Poptip>
</template>

<script>
export default {
  name: "table-filter",
  props: {
    filterList: Array,
    isState: Boolean,
  },
  data() {
    return {
      showPop: false,
      checkedItem: [],
      savedItem: [],
      value: "",
      checkAll: false,
      indeterminate: false,
      checkAllGroup: [],
    };
  },
  methods: {
    // 确定
    handleSave() {
      this.savedItem = this.checkedItem;
      this.showPop = false;
      this.$emit("on-ok", this.checkedItem);
    },
    // 重置
    handleCancel() {
      this.checkedItem = [];
      this.savedItem = [];
      this.showPop = false;
      this.$emit("on-reset");
    },
    // 提示框消失
    handleHide() {
      this.checkedItem = this.savedItem;
    },
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      if (this.checkAll) {
        this.checkAllGroup = ["1", "2", "3", "4"];
      } else {
        this.checkAllGroup = [];
      }
    },
    checkAllGroupChange(data) {
      if (data.length === 4) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
  },
};
</script>

<style scoped>
.filter-checked {
  color: #5cadff;
}

.filter-footer {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #ddd;
  text-align: right;
}
.filter-footer-content {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}
/* .filter-footer-left {
  float: left;
} */
.dataNull {
  height: 180px;
  /* width: 100%; */
  line-height: 180px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/my-components/table-filter-input/fiter-input.vue